import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

interface SettingsSectionProps {
  children: ReactNode;
  title: string;
}

export const SettingsSection = ({ title, children }: SettingsSectionProps) => (
  <section className="flex w-full flex-col rounded-xl border border-primary bg-primary">
    <div className="px-6 py-5">
      <Typography variant="label-md" component="h3">
        {title}
      </Typography>
    </div>
    {children}
  </section>
);
